import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { getSystemTimeZone, getValueFromResource } from '../../common/timeLiveFunction'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import AttendanceFiltersNew from './AttendanceFiltersNew';
import AttendanceTable from './Attendancetable';
import moment from 'moment';
import PageSizeSelect from '../../common/PageSizeSelect';
import { AttendanceAsync, checkPermissionsForAttendanceAsync, getAccountEmployeesForDropDownAsync, getBreaksAsync, getEmployeeAttendanceByEmployeeIdAndDateRangeAsync, getLastAttendanceAsync, getLastAttendanceBySystemAttendanceIdAsync, getShiftPermissionsAsync, setPageSize, updateIsLoading, updateLoader, updatePagination } from './AttendanceSlice';
import CustomPagination from "../../common/Pagination";
import { ShowToast } from '../../common/Toastr';
import { ShowSwalError, ShowSwalWithConfirmation } from '../../common/SweetAlert';
import ClockInLocationModal, { ClockLocationAction } from './ClockInLocationModal';
import { getCustomPagePermissionsAsync, getPagePermissionsAsync } from '../../common/GlobalSlice';
import { useLocation, useNavigate } from 'react-router-dom';

const SYSTEM_ATTENDANCE_TYPE_ID: Record<string, string> = {
    Attendance: "D5E53B7F-3489-4359-9B8E-808143827629",
    Break: "36D3465F-B775-4E36-A00E-A3B5C3AE78D1",
};

const getSystemAttendanceTypeId = (systemAttendanceType: string) =>
    SYSTEM_ATTENDANCE_TYPE_ID[systemAttendanceType] ?? "";

const getDeviceInformation = () => {
    const ua = navigator.userAgent;

    let os = "Unknown";
    if (ua.indexOf("Win") !== -1) os = "Windows";
    else if (ua.indexOf("Mac") !== -1) os = "MacOS";
    else if (ua.indexOf("Linux") !== -1) os = "Linux";
    else if (/Android/.test(ua)) os = "Android";
    else if (/iPhone|iPad|iPod/.test(ua)) os = "iOS";

    let browser = "Unknown";
    let version = "Unknown";

    if (/Edg\/([0-9.]+)/.test(ua)) {
        browser = "Edge";
        version = ua.match(/Edg\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (/Chrome\/([0-9.]+)/.test(ua) && !/Edg/.test(ua)) {
        browser = "Chrome";
        version = ua.match(/Chrome\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (/Firefox\/([0-9.]+)/.test(ua)) {
        browser = "Firefox";
        version = ua.match(/Firefox\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (/Safari\/([0-9.]+)/.test(ua) && /Version\/([0-9.]+)/.test(ua)) {
        browser = "Safari";
        version = ua.match(/Version\/([0-9.]+)/)?.[1] || "Unknown";
    }

    return `${os}/${version}/${browser} `;
};

const formatTime = (time: Date) => {
    let hours = time.getHours();
    const minutes = time.getMinutes().toString().padStart(2, '0');
    const seconds = time.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes}:${seconds} ${ampm}`;
}

const pad = (n: number) => (n < 10 ? "0" + n : String(n));

const convertSecondIntoHoursMinutes = (totalSeconds: number) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mnts = Math.floor((totalSeconds % 3600) / 60);
    return `${pad(hrs)}:${pad(mnts)}`;
}

const convertSecondIntoHoursMinutesSeconds = (totalSeconds: number) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mnts = Math.floor((totalSeconds % 3600) / 60);
    const secs = Math.floor(totalSeconds % 60);
    return `${pad(hrs)}:${pad(mnts)}:${pad(secs)}`;
};

const LiveClock = ({ className }: { className?: string }) => {
    const [time, setTime] = useState<Date>(new Date());

    useEffect(() => {
        const timerId = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timerId);
    }, []);

    return <label className={className}>{formatTime(time)}</label>;
};

const AttendanceList = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { AccountEmployeeAttendanceList, isAllowedLocationInWeb, pageNo, pageSize, search, startRec, CanStartBreak, breakList, resultId, CanCheckOut, CanEndBreak, startDateAttendance, endDateAttendance, sortColumn, direction, ActiveBreakId } = useAppSelector((state) => state.attendance);
    const { pageId, menuList, IsAdd, ProfileTimeZoneIANA } = useAppSelector((state) => state.globalState);
    const [showFilters, setShowFilters] = useState(false);
    const [isGetAttendance, setIsGetAttendance] = useState(false);
    const [activeAccountBreakId, setActiveAccountBreakId] = useState<any>(0);
    const [isBreakMenuOpen, setIsBreakMenuOpen] = useState(false);
    const [showClockInMap, setShowClockInMap] = useState(false);
    const [allowLocationInWeb, setAllowLocationInWeb] = useState(false);
    const [clockAction, setClockAction] = useState<ClockLocationAction>('clock-in');
    const [pendingBreakId, setPendingBreakId] = useState<any>(0);
    const confirmedLocationRef = useRef<{ latitude: number | string; longitude: number | string } | null>(null);
    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const [filters, setFilters] = useState({
        StartDate: moment().format('YYYY-MM-DD'),
        EndDate: moment().format('YYYY-MM-DD'),
        searchEmployeeId: AccountEmployeeId ?? '',
        searchEmployeeIds: AccountEmployeeId ?? '',
        accountDepartmentId: '',
        accountLocationId: '',
        employeeTypeId: undefined,
        attendanceSourceId: '',
        employeeStatus: 0,
    })

    // useEffect(() => {
    //     const previousOverflow = document.body.style.overflow;
    //     document.body.style.overflow = 'hidden';
    //     return () => {
    //         document.body.style.overflow = previousOverflow;
    //     };
    // }, []);

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            const dropdown = document.getElementById('btnGetAllBreak');
            const menu = document.querySelector('.break-container');

            if (dropdown && !dropdown.contains(event.target as Node) &&
                menu && !menu.contains(event.target as Node)) {
                setIsBreakMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(186));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(186));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        }
        getCustomPagePermissionsAsync("507");
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        dispatch(getAccountEmployeesForDropDownAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                const commaSeparatedValues = originalPromiseResult.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ');
                const SearchParamsValues = { page: pageNo, pageSize: pageSize, start: startRec, Order: sortColumn, OrderDir: direction, search: " ", StartDate: `${moment(startDateAttendance).format('MM-DD-YYYY')}`, EndDate: `${moment(endDateAttendance).format('MM-DD-YYYY')}`, AccountEmployeeIds: `${commaSeparatedValues.length === 0 ? "0" : commaSeparatedValues}` };
                dispatch(getEmployeeAttendanceByEmployeeIdAndDateRangeAsync(SearchParamsValues));
            })
            .catch(() => { });

        dispatch(checkPermissionsForAttendanceAsync());
        dispatch(getLastAttendanceBySystemAttendanceIdAsync(getSystemAttendanceTypeId("Attendance"))).then(() => {
            dispatch(getBreaksAsync(moment().format("YYYY-MM-DD")));
        })
    }, []);

    useEffect(() => {
        if (isGetAttendance) {
            dispatch(getLastAttendanceBySystemAttendanceIdAsync(getSystemAttendanceTypeId("Attendance")));
            dispatch(checkPermissionsForAttendanceAsync());
            dispatch(updateIsLoading(false));
            setIsGetAttendance(false);
        }
    }, [isGetAttendance, dispatch]);

    const totalItems = useMemo(() => AccountEmployeeAttendanceList?.[0]?.TotalRecords ?? 0, [AccountEmployeeAttendanceList]);

    const resetToFirstPage = useCallback((size: number) => {
        dispatch(updatePagination({
            startRec: 0,
            pageSize: size,
            pageNo: 1,
            search: search
        }));
    }, [dispatch, search]);

    const handlePageSizeChange = useCallback((event: any) => {
        const { value } = event;
        dispatch(setPageSize(Number(value)));
        resetToFirstPage(Number(value));
    }, [dispatch, resetToFirstPage]);

    const handlePageChange = useCallback((pageNumber: any) => {
        dispatch(updatePagination({
            startRec: (pageNumber - 1) * Number(pageSize),
            pageSize: pageSize,
            pageNo: pageNumber,
            search: search
        }));
    }, [dispatch, pageSize, search]);

    const handleApplyFilter = useCallback((newFilters: any) => {
        setFilters({
            ...newFilters,
        });
        resetToFirstPage(pageSize);
    }, [pageSize, resetToFirstPage]);

    const isTimeZoneMismatched = useCallback(() => {
        const systemTZ = getSystemTimeZone();
        if (systemTZ?.trim().toLowerCase() !== ProfileTimeZoneIANA?.trim().toLowerCase()) {
            ShowToast('Error', 'System and TimeLive profile time zone must match.', "error", "toast-top-right");
            return true;
        }
        return false;
    }, [ProfileTimeZoneIANA]);

    const showLocationMessage = useCallback(() => {
        ShowToast("As per your company policy, you need to allow access to your location for clock-in/clock-out", "", "warning");
    }, []);

    const addAttendance = useCallback((SystemAttendanceTypeId: any, Status: any, AccountBreakId: any, Latitude: any = "", Longitude: any = "") => {
        const currentDate = new Date();
        const Time = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;
        const DateOnly = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
        const deviceInfo = getDeviceInformation();

        const ajaxParam = {
            AccountId,
            AccountEmployeeId,
            SystemAttendanceTypeId,
            Status,
            Latitude,
            Longitude,
            SystemEntryModeId: 2,
            TimeIn: Time,
            TimeOut: Time,
            AttendanceDate: DateOnly,
            DeviceInformation: deviceInfo,
            Speed: 0,
            Heading: 0,
            Altitude: 0,
            Accuracy: 0,
            MeanCn0: 0,
            MaxCn0: 0,
            Satellites: 0,
            LocationTimestamp: 0,
            AccountBreakId: (Status === 3 || Status === 4) ? AccountBreakId : '',
            AllowAttendanceOutsideZone: false,
        };

        // dispatch(AttendanceAsync(ajaxParam))
        // .unwrap()
        // .then((originalPromiseResult) => {
        //     if (originalPromiseResult.StatusCode === "201") {
        //         setIsGetAttendance(true);
        //     } else {
        //         ShowToast("Warning", originalPromiseResult.ResponseMessage, "warning", "toast-top-right");
        //         setIsGetAttendance(true);
        //     }
        // })
        // .catch((rejectedValueOrSerializedError) => {
        //     ShowToast("error", rejectedValueOrSerializedError, "error", "toast-top-right");
        // });
        const submitAttendance = (payload: typeof ajaxParam) => {
            dispatch(AttendanceAsync(payload))
                .unwrap()
                .then((originalPromiseResult) => {
                    const isOutsideZoneConfirmation = originalPromiseResult?.Id === "OUTSIDE_ZONE_CONFIRMATION"
                        && String(originalPromiseResult?.StatusCode) === "400";
                    const isAttendanceBlocked = originalPromiseResult?.Id == null
                        && String(originalPromiseResult?.StatusCode) === "400";

                    if (originalPromiseResult.StatusCode === "201") {
                        setIsGetAttendance(true);
                    } else if (isOutsideZoneConfirmation && !payload.AllowAttendanceOutsideZone) {
                        dispatch(updateLoader(false));
                        ShowSwalWithConfirmation( "Confirmation Required", originalPromiseResult.ResponseMessage, "Proceed anyway").then((confirmed) => {
                            if (confirmed) {
                                submitAttendance({ ...payload, AllowAttendanceOutsideZone: true });
                            }
                        });
                    } else if (isAttendanceBlocked) {
                        dispatch(updateLoader(false));
                        ShowSwalError('Error', originalPromiseResult.ResponseMessage);
                    } else {
                        ShowToast("Warning", originalPromiseResult.ResponseMessage, "warning", "toast-top-right");
                        setIsGetAttendance(true);
                    }
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast("error", rejectedValueOrSerializedError, "error", "toast-top-right");
                });
        };

        submitAttendance(ajaxParam);
    }, [AccountId, AccountEmployeeId, dispatch]);

    const addAttendanceByLocation = useCallback((latitude: any, longitude: any, attendanceStatus: any, accountBreakId: any) => {
        const hasValidLocation = latitude != null && latitude != "" && latitude != 0;

        if (attendanceStatus === 0) {
            hasValidLocation ? addAttendance(getSystemAttendanceTypeId("Attendance"), 1, 0, latitude, longitude) : showLocationMessage();
        } else if (attendanceStatus === 1) {
            hasValidLocation ? addAttendance(getSystemAttendanceTypeId("Break"), 3, accountBreakId, latitude, longitude) : showLocationMessage();
        } else if (attendanceStatus === 2) {
            hasValidLocation ? addAttendance(getSystemAttendanceTypeId("Attendance"), 2, 0, latitude, longitude) : showLocationMessage();
        } else if (attendanceStatus === 4) {
            hasValidLocation ? addAttendance(getSystemAttendanceTypeId("Break"), 4, accountBreakId, latitude, longitude) : showLocationMessage();
        }else {
            showLocationMessage();
        }
    }, [addAttendance, showLocationMessage]);

    const getUserLocation = useCallback((attendanceStatus: any, accountBreakId: any) => {
        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition(
            (position) => {
                addAttendanceByLocation(position.coords.latitude, position.coords.longitude, attendanceStatus, accountBreakId)
            },
            (error) => {
                dispatch(updateLoader(false));
                ShowToast('error', error?.code === 1 ? 'Location access is blocked. Please allow location sharing in your browser settings and try again.' : error?.message, "error", "toast-top-right");
            },
            {
                enableHighAccuracy: true,
                timeout: 15000,
                maximumAge: 0,
            }
        );
    }, [addAttendanceByLocation, dispatch]);

    const handleAutoClockIn = useCallback(() => {
        if (isTimeZoneMismatched()) return;

        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.Data[0].AllowLocationInWeb == true) {
                    getUserLocation(0, 0);
                } else {
                    addAttendance(getSystemAttendanceTypeId("Attendance"), 1, 0, "0", "0");
                }
            })
            .catch(() => { })
    }, [isTimeZoneMismatched, dispatch, getUserLocation, addAttendance]);

    const handleStartBreak = useCallback((accountBreakId: any) => {
        if (isTimeZoneMismatched()) return;
        setActiveAccountBreakId(accountBreakId);
        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.Data[0].AllowLocationInWeb == true) {
                    getUserLocation(1, accountBreakId);
                } else {
                    addAttendance(getSystemAttendanceTypeId("Break"), 3, accountBreakId, "0", "0");
                }
            })
            .catch(() => { })
    }, [isTimeZoneMismatched, dispatch, getUserLocation, addAttendance]);

    let latestBreakId = activeAccountBreakId == 0 ? ActiveBreakId : activeAccountBreakId
    const handleEndBreak = useCallback(() => {
        if (isTimeZoneMismatched()) return;
        // addAttendance(getSystemAttendanceTypeId("Break"), 4, latestBreakId, "0", "0");
        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.Data[0].AllowLocationInWeb == true) {
                    getUserLocation(4, latestBreakId);
                } else {
                    addAttendance(getSystemAttendanceTypeId("Break"), 4, latestBreakId, "0", "0");
                }
            })
            .catch(() => { })
    }, [isTimeZoneMismatched, dispatch, getUserLocation, addAttendance, latestBreakId]);

    const handleClockOut = useCallback(() => {
        if (isTimeZoneMismatched()) return;
        // addAttendance(getSystemAttendanceTypeId("Attendance"), 2, 0, "0", "0");
        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.Data[0].AllowLocationInWeb == true) {
                    getUserLocation(2, 0);
                } else {
                    addAttendance(getSystemAttendanceTypeId("Attendance"), 2, 0, "0", "0");
                }
            })
            .catch(() => { })
    }, [isTimeZoneMismatched, dispatch, getUserLocation, addAttendance]);

    const openClockLocationModal = (action: ClockLocationAction, accountBreakId: any = 0) => {
        if (isTimeZoneMismatched()) return;
        if (action === 'break-in') setActiveAccountBreakId(accountBreakId);
        setClockAction(action);
        setPendingBreakId(accountBreakId);
        dispatch(getShiftPermissionsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                setAllowLocationInWeb(originalPromiseResult?.Data?.[0]?.AllowLocationInWeb == true);
                dispatch(updateLoader(false));
                setShowClockInMap(true);
            })
            .catch(() => { })
    };

    const confirmClockLocation = (latitude: number | string, longitude: number | string) => {
        confirmedLocationRef.current = { latitude, longitude };
        setShowClockInMap(false);
        if (clockAction === 'clock-in') {
            handleAutoClockIn();
        } else if (clockAction === 'break-in') {
            handleStartBreak(pendingBreakId);
        } else if (clockAction === 'break-out') {
            handleEndBreak();
        } else {
            handleClockOut();
        }
    };

    const handleGetAllBreaks = useCallback(() => {
        dispatch(getBreaksAsync(moment().format("YYYY-MM-DD")));
    }, [dispatch]);

    return (
        <div>
            <div className="card card-custom admin-card admin-card-Scroll">
                <div className="card-header card-drop sticky-top bg-white fixed-top admin-card-header-sticky">
                    <h3 className="card-title fw-bold headerTitle" style={{ lineHeight: 1 }}>
                        {getValueFromResource('Attendance List', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="d-flex align-items-center">
                            <PageSizeSelect onChange={handlePageSizeChange} />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(totalItems > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={startRec}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <button
                            onClick={() => setShowFilters(prev => !prev)}
                            className={`btn btn-sm d-flex align-items-center gap-2 btn-primary`}
                            style={{ fontWeight: 500 }}
                        >
                            <i className="ki-duotone ki-filter fs-6">
                                <span className="path1" />
                                <span className="path2" />
                            </i>
                            {getValueFromResource('Filters', dispatch, t)}
                            <i className={`ki-duotone ${showFilters ? 'ki-up' : 'ki-down'} fs-7`}>
                                <span className="path1" />
                                <span className="path2" />
                            </i>
                        </button> */}
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        {IsAdd && (resultId == 0 ? (
                            <button id="btnCheckIn" className="btn btn-sm btn-success btn-in-out cursor-pointer" style={{ padding: '2px 22px' }}
                                // onClick={handleAutoClockIn}>
                               onClick={() => openClockLocationModal('clock-in')}>
                                <i className="ki-outline ki-time text-default fs-1"></i>
                                <span>
                                    {getValueFromResource('Clock In', dispatch, t)}
                                </span>
                                <LiveClock className="currentTime cursor-pointer" />
                            </button>
                        ) : (
                            (CanStartBreak && CanCheckOut && CanEndBreak == false) ? (
                                <>
                                    <button id="btnGetAllBreak"
                                        className="btn btn-secondary dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        data-close-others="false"
                                        onClick={() => {
                                            // handleGetAllBreaks();
                                            if (!isBreakMenuOpen) handleGetAllBreaks();
                                            setIsBreakMenuOpen(!isBreakMenuOpen);
                                        }}
                                        style={{ padding: '9px 24px' }}
                                    >
                                        <i className="ki-outline ki-time text-default fs-1"></i>
                                        <span style={{ padding: '6px' }}>
                                            {getValueFromResource('Break', dispatch, t)}
                                        </span>
                                        <i className="fa fa-angle-down" style={{ msGridColumns: 3 }}></i>
                                    </button>
                                    <div
                                        className="dropdown-menu pull-right break-container"
                                        role="menu"
                                        style={{ marginTop: "10px", padding: '18px' }}
                                    >
                                        {Object.keys(breakList).length === 0 ? (
                                            <div className="portlet-title">
                                                <div className="caption ">
                                                    <span id="spanBreak" className="caption-subject bold grayColor">
                                                        {getValueFromResource('No Breaks Available', dispatch, t)}
                                                    </span>
                                                </div>
                                            </div>
                                        ) :
                                            (
                                                <>
                                                    <div className="portlet-title"></div>
                                                    <div className="portlet-body portletBody" id="breakBody">
                                                        {breakList.map((obj: any, index: any) => {
                                                            const breakType = obj.BreakType;
                                                            const breakDuration = convertSecondIntoHoursMinutes(obj.TotalBreakInSeconds);
                                                            const accountBreakId = obj.AccountBreakId;
                                                            const remainingDuration = convertSecondIntoHoursMinutesSeconds(obj.RemainingSeconds);
                                                            const consumedDuration = convertSecondIntoHoursMinutesSeconds(obj.TotalConsumedSeconds);
                                                            const shiftName = obj.ShiftName;
                                                            return (
                                                                <div key={accountBreakId ?? index} className="breakBody d-body">
                                                                    <div className="row">
                                                                        <div className="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center" style={{ paddingTop: '5px' }}>
                                                                            <span id="spnBreakName" className="caption-subject fw-bold blackColor pl-3">{breakType}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center" style={{ paddingLeft: '24px', paddingTop: '11px' }}>
                                                                            <i className="ki-outline ki-time text-default" style={{ fontSize: '2.5rem', color: 'red', marginRight: '10px' }}></i>
                                                                            <div>
                                                                                <div>
                                                                                    <span>{getValueFromResource('Remaining Duration', dispatch, t)}: {remainingDuration}</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span>{getValueFromResource('Consumed Duration', dispatch, t)}: {consumedDuration}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-1">
                                                                        <div className="col-md-3 col-sm-3 col-xs-12 breakDuration" style={{ color: 'red' }}>
                                                                            <div className="pull-left" style={{ paddingLeft: '15px' }}>
                                                                                <span>{breakDuration}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                                                            <div className="pull-left" style={{ paddingLeft: '15px' }}>
                                                                                <button className="btn btn-success btn-sm"
                                                                                    onClick={() => {
                                                                                        // handleStartBreak(accountBreakId)
                                                                                        openClockLocationModal('break-in', accountBreakId)
                                                                                        setIsBreakMenuOpen(!isBreakMenuOpen);
                                                                                    }
                                                                                    }
                                                                                    style={{ padding: '5px' }}
                                                                                >
                                                                                    <span>
                                                                                        {getValueFromResource('Start', dispatch, t)}
                                                                                    </span>&nbsp;
                                                                                    <i className="fa fa-play-circle" style={{ color: 'white' }}></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="assignedShift" style={{ padding: '7px 0px 8px 25px' }}>
                                                                            <span className="bold" id="spnAssignedShift">
                                                                                {getValueFromResource('Assigned Shift :', dispatch, t)}
                                                                            </span>
                                                                            <span id="spanShiftName" className="pl-3">{shiftName}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                    <button id="btnCheckOut" className="btn btn-sm btn-danger btn-in-out"
                                    // onClick={handleClockOut}
                                        onClick={() => openClockLocationModal('clock-out')}
                                        style={{ padding: '2px 22px', minWidth: '157px' }} >
                                        <i className="ki-outline ki-time text-default fs-1"></i>
                                        <span >
                                            {getValueFromResource('Clock Out', dispatch, t)}
                                        </span>
                                        <LiveClock className="currentTime cursor-pointer" />
                                    </button>
                                </>
                            ) :
                                (
                                    <button id="btnCheckOut" className="btn btn-sm btn-danger btn-in-out"
                                    // onClick={handleEndBreak}
                                        onClick={() => openClockLocationModal('break-out')}
                                        style={{ padding: '2px 22px', minWidth: '159px' }} >
                                        <i className="ki-outline ki-time text-default fs-1"></i>
                                        <span >
                                            {getValueFromResource('Break Out', dispatch, t)}
                                        </span>
                                        <LiveClock className="currentTime" />
                                    </button>
                                )
                        ))}
                    </div>
                </div>
                {/* <div
                    style={{
                        maxHeight: showFilters ? 500 : 0,
                        overflow: 'hidden',
                        transition: 'max-height 0.3s ease',
                        borderBottom: showFilters ? '1px solid #E9ECEF' : 'none',
                    }}
                > */}
                <div className="card-body p-0 admin-card-body">
                    <div className="py-2" style={{ flexShrink: 0 }}>
                        <AttendanceFiltersNew setShowFilters={setShowFilters} onApplyFilter={handleApplyFilter} onClearFilter={handleApplyFilter} />
                    </div>
                    {/* </div> */}
                    <div style={{ flex: 1, overflowY: 'hidden', minHeight: 0 }}>
                        <AttendanceTable filters={filters} isBreakMenuOpen={isBreakMenuOpen} />
                    </div>
                </div>
            </div>
            <ClockInLocationModal
                isOpen={showClockInMap}
                requireLocation={allowLocationInWeb}
                useNavigatorLocation={allowLocationInWeb}
                action={clockAction}
                onClose={() => setShowClockInMap(false)}
                onConfirm={(latitude, longitude) => confirmClockLocation(latitude, longitude)}
            />
        </div>
    )
}

export default AttendanceList